import { SquareFunction } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SquareFunctionIcon = createLucideIcon(SquareFunction);
